import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Logo from './common/Logo';
import appConfig from '../config/app';

const Footer = ({ auth }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{
      background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
      color: 'white',
      padding: '3rem 0 2rem',
      marginTop: '0'
    }}>
      <div className="container">
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '1.5rem'
        }}>
          {/* Logo */}
          <Link to="/" style={{ textDecoration: 'none' }}>
            <Logo size={32} color="white" showText={true} />
          </Link>

          {/* Tagline */}
          <p style={{
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: '0.95rem',
            margin: 0,
            textAlign: 'center'
          }}>
            Your story, ready for all platforms
          </p>

          {/* Navigation Links */}
          <div style={{
            display: 'flex',
            gap: '2rem',
            flexWrap: 'wrap',
            justifyContent: 'center'
          }}>
            <Link
              to="/free"
              style={{
                color: 'rgba(255, 255, 255, 0.8)',
                textDecoration: 'none',
                fontSize: '0.875rem',
                transition: 'color 0.2s'
              }}
              onMouseOver={(e) => e.target.style.color = 'white'}
              onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
            >
              Try It Free
            </Link>
            <Link
              to="/contact"
              style={{
                color: 'rgba(255, 255, 255, 0.8)',
                textDecoration: 'none',
                fontSize: '0.875rem',
                transition: 'color 0.2s'
              }}
              onMouseOver={(e) => e.target.style.color = 'white'}
              onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
            >
              Contact
            </Link>
            <Link
              to="/privacy-policy"
              style={{
                color: 'rgba(255, 255, 255, 0.8)',
                textDecoration: 'none',
                fontSize: '0.875rem',
                transition: 'color 0.2s'
              }}
              onMouseOver={(e) => e.target.style.color = 'white'}
              onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms-of-service"
              style={{
                color: 'rgba(255, 255, 255, 0.8)',
                textDecoration: 'none',
                fontSize: '0.875rem',
                transition: 'color 0.2s'
              }}
              onMouseOver={(e) => e.target.style.color = 'white'}
              onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
            >
              Terms of Service
            </Link>
          </div>

          {/* Divider */}
          <div style={{
            width: '100%',
            maxWidth: '400px',
            height: '1px',
            background: 'rgba(255, 255, 255, 0.1)',
            margin: '0.5rem 0'
          }} />

          {/* Copyright */}
          <div style={{
            color: 'rgba(255, 255, 255, 0.5)',
            fontSize: '0.75rem',
            textAlign: 'center'
          }}>
            {currentYear > 2026 ? `2026-${currentYear}` : '2026'} {appConfig.company.copyright}. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

function mapStateToProps({ auth }) {
  return { auth };
}

export default connect(mapStateToProps)(Footer);
